<template>
  <v-menu
    v-if="tooltipText"
    open-on-hover
    offset-x
    offset-y
    right
    max-width="200"
  >
    <template v-slot:activator="{ on }">
      <div v-on="on" class="badge-container" :class="color">
        {{ text }}
      </div>
    </template>

    <v-card>
      <v-card-text>
        <span class="tooltip-text pre-line">{{ tooltipText }}</span>
      </v-card-text>
    </v-card>
  </v-menu>

  <div v-else class="badge-container" :class="color">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'NavigationItemBadge',

  props: {
    text: String,
    tooltipText: String,
    color: String,
  },
}
</script>

<style lang="scss" scoped>
.badge-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 1px 4px;
  color: #fff;
  font-size: 10px;
}

.tooltip-text {
  color: $color-blue-grey-darken2;
}
</style>
